// @flow

/** @jsx h */

import { Component, h } from 'preact'
import { createSrcSet, getQualityFromString, supportedWidths } from 'image'
import { createImageUrl } from '@nrk/serum-imagecrop-utils'

export type Image = {
  id: string,
  quality?: 'low' | 'medium' | 'high' | 'very-high'
}

type Props = {
  alt: string,
  className?: string,
  horizontal: Image,
  vertical?: Image
}

class Picture extends Component<Props> {
  render () {
    const { className, alt, horizontal, vertical } = this.props
    const horizontalId = horizontal && horizontal.id && horizontal.id
    const verticalId = vertical && vertical.id && vertical.id.trim()

    if (vertical && verticalId) {
      if (!horizontalId) {
        return <div className={className}>Mangler ID</div>
      }

      const defaultUrl = createImageUrl({
        id: horizontalId,
        width: 1600,
        quality: getQualityFromString(horizontal.quality)
      })
      const horizontalSourceSet = createSrcSet({
        imageId: horizontalId,
        supportedWidths,
        quality: getQualityFromString(horizontal.quality)
      })
      const verticalSourceSet = createSrcSet({
        imageId: verticalId,
        supportedWidths,
        quality: getQualityFromString(vertical.quality)
      })

      return (
        <picture className={className}>
          <source
            media='(min-aspect-ratio: 3/4)'
            srcSet={horizontalSourceSet}
          />
          <source media='(max-aspect-ratio: 3/4)' srcSet={verticalSourceSet} />
          <img src={defaultUrl} alt={alt} />
        </picture>
      )
    } else {
      const { quality } = horizontal
      const imageId = horizontal.id && horizontal.id.trim()

      if (!imageId) {
        return <div className={className}>Mangler ID</div>
      }

      const parsedQuality = getQualityFromString(quality)
      const defaultUrl = createImageUrl({
        id: imageId,
        ratio: '16:9',
        width: 1600,
        parsedQuality
      })
      const desktopSourceSet = createSrcSet({
        imageId,
        ratio: '16:9',
        supportedWidths,
        quality: parsedQuality
      })
      const mobileSourceSet = createSrcSet({
        imageId,
        ratio: '3:4',
        supportedWidths,
        quality: parsedQuality
      })

      return (
        <picture className={className}>
          <source media='(min-aspect-ratio: 3/4)' srcSet={desktopSourceSet} />
          <img src={defaultUrl} srcSet={mobileSourceSet} alt={alt} />
        </picture>
      )
    }
  }
}

export default Picture



// WEBPACK FOOTER //
// ./src/lib/@nrk/dh-feature-components/PolopolyPicture/index.js